import { BillingAccountPolicyKeys } from '@services/billing-account/useSearchBillingAccountPolicies';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export type UpdatePaymentRequestPostRequestBody = {
  error?: string;
  completedAt?: string;
};

export const useUpdatePaymentRequest = () => {
  const client = useClient();
  const queryClient = useQueryClient();

  const mutationFn = async ({ id, requestBody }: { id: string; requestBody: UpdatePaymentRequestPostRequestBody }) => {
    const url = `payment-request/${id}`;

    const res = await client.patch(url, {
      json: {
        completedAt: requestBody.completedAt,
        error: requestBody.error ?? null,
      },
    });
    return res.json();
  };
  const result = useMutation({
    mutationFn,
    onSuccess: async () => {
      // clear all billing account policies (FUTURE: only clear ones payment was made on)
      await queryClient.refetchQueries({
        predicate: (query) => {
          return query.queryKey.includes(BillingAccountPolicyKeys.search[0]);
        },
      });
    },
  });
  return { ...result, updatePaymentRequest: result.mutateAsync };
};
